module.exports = __webpack_public_path__ + "img/16_21.b7a7171b.png";